import { useState, useCallback } from 'react';

const DEFAULT_FLAGS = {
  showOfferBanner: true,
  showSocialProof: true,
  showChatbot: false,
  showExitIntent: true,
  enableDarkMode: false,
  showAnnouncement: true,
};

const STORAGE_KEY = 'feature_flags';

function loadFlags() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return { ...DEFAULT_FLAGS, ...JSON.parse(stored) };
    }
  } catch {
    // Ignore parse errors, fall back to defaults
  }
  return { ...DEFAULT_FLAGS };
}

function useFeatureFlags() {
  const [flags, setFlags] = useState(loadFlags);

  const isEnabled = useCallback(
    (flagName) => {
      return Boolean(flags[flagName]);
    },
    [flags]
  );

  const setFlag = useCallback(
    (flagName, value) => {
      setFlags((prev) => {
        const updated = { ...prev, [flagName]: value };
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        } catch {
          // Ignore storage errors (quota exceeded, etc.)
        }
        return updated;
      });
    },
    []
  );

  return { flags, isEnabled, setFlag };
}

export default useFeatureFlags;
